import { render } from "./MyMonthlyDeclaration.vue?vue&type=template&id=11b7c894&scoped=true"
import script from "./MyMonthlyDeclaration.vue?vue&type=script&lang=js"
export * from "./MyMonthlyDeclaration.vue?vue&type=script&lang=js"

import "./MyMonthlyDeclaration.vue?vue&type=style&index=0&id=11b7c894&lang=scss&scoped=true"
import "./MyMonthlyDeclaration.vue?vue&type=style&index=1&id=11b7c894&lang=scss"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b7c894"]])

export default __exports__